// extracted by mini-css-extract-plugin
export default {"tableOverride":"_10-HumanImpacts_tableOverride__dfUI6"};